import React from 'react';

interface StateSpanProp {
  currentState: boolean
  greenState: string
  redState: string
}

const StateSpanForTable = ({
  currentState,
  greenState,
  redState,
}: StateSpanProp) => {
  return currentState ? (
    <span className="rounded-full bg-green-200 px-2 py-1 text-center font-semibold text-green-700">
      {greenState}
    </span>
  ) : (
    <span className="rounded-full bg-red-200 px-2 py-1 text-center font-semibold text-red-700">
      {redState}
    </span>
  )
}

export default StateSpanForTable
